import React from "react";
import SearchBar from "./SearchBar";

const FilterSection = ({
  title,
  options,
  selected,
  onChange,
  multiSelect = false,
  optionValueKey = null,
  optionLabelKey = null,
  search,
  handleSearchChange,
  customContent
}) => {
  console.log(`FilterSection ${title} render:`, { options, selected, multiSelect, optionValueKey, optionLabelKey });
  // Handle rendering options that come from API where we need to extract values and labels
  const renderOption = (option) => {
    // If the option is an object with specified value and label keys
    if (
      typeof option === "object" &&
      option !== null &&
      optionValueKey &&
      optionLabelKey
    ) {
      const label = option[optionLabelKey];
      console.log(`FilterSection ${title}: renderOption for object:`, { option, optionLabelKey, label });
      return label;
    }
    // If option is a simple string
    console.log(`FilterSection ${title}: renderOption for primitive:`, { option });
    return option;
  };

  // Get the option value (either the option itself for strings or the value property for objects)
  const getOptionValue = (option) => {
    if (typeof option === "object" && option !== null && optionValueKey) {
      const value = option[optionValueKey];
      console.log(`FilterSection ${title}: getOptionValue for object:`, { option, optionValueKey, value });
      return value;
    }
    console.log(`FilterSection ${title}: getOptionValue for primitive:`, { option });
    return option;
  };

  // Check if an option is selected (handles both single and multi-select)
  const isSelected = (option) => {
    const optionValue = getOptionValue(option);
    const result = multiSelect
      ? Array.isArray(selected) && selected.includes(optionValue)
      : selected === optionValue;

    console.log(`FilterSection ${title}: isSelected for ${optionValue}:`, result, { selected, multiSelect, optionValue });
    return result;
  };

  // Handle option click based on selection mode
  const handleOptionClick = (option) => {
    const optionValue = getOptionValue(option);
    console.log(`FilterSection ${title}: option clicked`, { option, optionValue, multiSelect, selected });

    if (multiSelect) {
      // For multi-select, toggle selection
      if (Array.isArray(selected)) {
        if (selected.includes(optionValue)) {
          const newSelection = selected.filter((item) => item !== optionValue);
          console.log(`FilterSection ${title}: removing from selection:`, newSelection);
          onChange(newSelection);
        } else {
          const newSelection = [...selected, optionValue];
          console.log(`FilterSection ${title}: adding to selection:`, newSelection);
          onChange(newSelection);
        }
      } else {
        console.log(`FilterSection ${title}: initializing multi-select with:`, [optionValue]);
        onChange([optionValue]);
      }
    } else {
      // For single select, toggle if already selected, otherwise set value
      if (selected === optionValue) {
        console.log(`FilterSection ${title}: unselecting single selection:`, optionValue);
        onChange(null);
      } else {
        console.log(`FilterSection ${title}: setting single selection to:`, optionValue);
        onChange(optionValue);
      }
    }
  };

  return (
    <div className="space-y-2 border-b-[0.5px] border-[#6561611a] p-4 !pt-0">
      <p className="font-[600] text-[14px] font-poppins text-[#303030]">
        {title}
      </p>
      {search !== undefined && <SearchBar
        parentDivClass="w-full"
        divClassName="relative"
        inputClassName="searchBar w-full p-3 text-[14px] font-poppins font-[400] outline-none"
        iconClassName="absolute sm:right-[5%] sm:bottom-[30%] lg:right-[3%]"
        placeholder="Search"
        value={search}
        handleChange={(e) => handleSearchChange(e.target.value)}
      />}
      <div className="flex gap-2 flex-wrap">
        {options && options.length > 0 ? (
          options.map((option, index) => {
            const optionValue = getOptionValue(option);
            const isOptionSelected = isSelected(option);
            const optionLabel = renderOption(option);
            console.log(`FilterSection ${title}: rendering option ${index}:`, { option, optionValue, isOptionSelected, optionLabel });
            return (
              <button
                key={index}
                onClick={() => handleOptionClick(option)}
                className={`px-3 h-[28px] rounded-full text-[13px] font-[500] font-poppins ${isOptionSelected
                  ? "bg-[#00ADEF] text-white"
                  : "bg-[#E5E5E5] text-[#8C8C8C]"
                  }`}
              >
                {optionLabel}
              </button>
            );
          })
        ) : (
          <span className="text-gray-500">No options available</span>
        )}
      </div>
      {/* Render custom content if provided (e.g. date picker) */}
      {typeof customContent === 'function' ? customContent(selected) : customContent}
    </div>
  );
};

export default FilterSection;
